"use client";

import { createContext, useContext } from "react";
import type { EventBucket } from "@/lib/events/event-lifecycle";

export interface EventOption {
  value: string;
  label: string;
  /** Lifecycle bucket, so the switcher can order Active-first and tag Past/Cancelled rows. */
  bucket?: EventBucket;
  startDate?: string | null;
  endDate?: string | null;
}

const EventOptionsContext = createContext<EventOption[]>([]);

/**
 * Provides event options to enterprise child components.
 */
export const EventOptionsProvider = ({
  eventOptions,
  children,
}: {
  eventOptions: EventOption[];
  children: React.ReactNode;
}) => {
  return <EventOptionsContext.Provider value={eventOptions}>{children}</EventOptionsContext.Provider>;
};

/**
 * Returns the list of accessible events for the current user.
 */
export const useEventOptions = () => useContext(EventOptionsContext);
